// extracted by mini-css-extract-plugin
module.exports = {"box":"FJAdjustItem_box__2xXhu"};